import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { Subcontractors } from '@app/models';

@Injectable({ providedIn: 'root' })
export class SubcontractorsService {
  constructor(private http: HttpClient, private api: ApiService) {}

  loadAll(): Observable<Subcontractors> {
    return this.http.get<Subcontractors>(`${this.api.url}/subcontractors`);
  }
}
